export const LEGAL_TERMS_VERSION = "1.0.0";

export const LEGAL_TEXT_VERSIONS = {
  legalNotice: LEGAL_TERMS_VERSION,
  privacyPolicy: LEGAL_TERMS_VERSION,
  cookiesPolicy: LEGAL_TERMS_VERSION,
};
